import Config from '@/shared/config/config';
import { LicenseInfo } from '@mui/x-license';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/router';

LicenseInfo.setLicenseKey(Config.MUI_LICENSE_KEY);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
